import { array, nonEmptyArray, record, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { useLocalizeEnum, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TreeOption } from '@mews/b2b-ui';
import { AccountingCategory, AccountingCategoryClassification } from '@mews-commander/data-access';
import { useActiveAccountingCategories } from './useActiveAccountingCategories';

export const useAccountingCategoryTreeOptions = (): TreeOption[] => {
    const activeAccountingCategories = useActiveAccountingCategories();
    const localizeText = useLocalizeText();
    const localizeEnum = useLocalizeEnum();

    if (!activeAccountingCategories || !array.isNonEmpty(activeAccountingCategories)) {
        return [];
    }

    return pipe(
        activeAccountingCategories,
        nonEmptyArray.groupBy(({ classification }) => classification ?? ''),
        record.toArray<AccountingCategoryClassification, NonEmptyArray<AccountingCategory>>,
        array.map(([classification, categories]) => {
            const classificationName = string.isEmpty(classification)
                ? localizeText({ textKey: TextKey.AllowanceFormOptionLabelUnclassifiedAccountingCategory })
                : localizeEnum('AccountingCategoryClassification', AccountingCategoryClassification[classification]);
            return {
                label: classificationName,
                id: classificationName,
                options: categories.map(({ name, id }) => ({ value: id, label: name, id })),
            };
        })
    );
};
